import React from "react";
import { registerDriverProfile } from "../../actions/commonActions";

import ProfileForm from "./ProfileForm";
import "./RegisterProfile.css";
const initialState = {
  first_name: "",
  last_name: "",
  title_code: "",
  date_of_birth: "",
  sex_code: "",
  sexRef: {
    sex_code: "",
    name: "",
  },
  street_line_1: "",
  street_line_2: "",
  zip_code: "",
  state_id: "",
  city_id: "",
  country_id: "",
  mobile_phone_number: "",
  address_type_code: "H", // Set Default as Home(H)
  referring_ev_charging_site_id: "",
};

export default function () {
  const onSubmit = (dispatch, payload) => {
    localStorage.setItem("showDoneButton", true);
    registerDriverProfile(dispatch, payload);
  };

  return <ProfileForm initialState={initialState} onSubmit={onSubmit} />;
}
